import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-progressbar-timer',
    templateUrl: './progressbar-timer.component.html',
    styleUrls: ['./progressbar-timer.component.css'],
    standalone: false
})
export class ProgressbarTimerComponent implements OnInit {
  value = 0;
  seconds = 0;
  interval: any;
  showing = true;
  progressType = 'bar-success';
  tooltipStr = '00:00';
  minutes: number;
  @Output() end = new EventEmitter<boolean>();
  @Input() start: EventEmitter<any>;
  @Input() clear: EventEmitter<boolean>;
  @Input() starttime: any;
  @Input() maxSeconds: number;
  @Input() yellowSeconds: number;
  @Input() redSeconds: number;
  @Input() setColorBlue: any;
  @Input() endtime: any;
  @Input() case_id:any;
  @Input() isAlert:boolean;
  @Output() timerflag = new EventEmitter<{}>();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    if (this.start) {
      this.start.subscribe(event => {
        this.showing = event.showing;
        if (this.showing === true) {
          this.timecalcul(event.start_time);
        }
      });
    }

    if (!this.start) {

      if (this.starttime && this.endtime) {
        this.seconds = this.calculateSeconds(this.starttime, this.endtime);
        this.setBarInfo();
      }
      else {
        this.timecalcul(this.starttime);
      }
    }

    if (this.clear) {
      this.clear.subscribe(event => {
      clearInterval(this.interval);
      this.value = 0;
      this.seconds = 0;
      this.progressType = 'bar-success';
    });
    }

    if (this.setColorBlue) {
      this.progressType = 'bar-info';
    }
  }

  calculateSeconds(start_time, end_time) {
    const start = new Date(start_time);
    const end = new Date(end_time);

    return Math.floor((end.getTime() - start.getTime()) / 1000);
  }

  timecalcul(start_time) {
    this.interval = setInterval(() => {
      if (start_time) {
        const d = new Date(start_time);
        const gmtHours = -new Date().getTimezoneOffset() * 60;
        this.seconds = Math.floor((Date.now() - d.getTime()) / 1000 - gmtHours);
      }
      else {
        this.seconds += 1;
      }

      this.setBarInfo();
    }, 1000);
  }

  setBarInfo() {
    if (this.setColorBlue) {
      this.progressType = 'bar-info';
    } else {
      if (this.seconds >= this.yellowSeconds && this.seconds < this.redSeconds) {
        this.progressType = 'bar-warning';
      }
      else if (this.seconds >= this.redSeconds) {
        this.progressType = 'bar-danger';
      }
      else {
        this.progressType = 'bar-success';
      }
    }
    this.value = Math.floor(this.seconds / this.maxSeconds * 100);
    let diff = Math.abs(this.seconds);
    const days = Math.floor(diff / 3600 / 24);
    diff = diff - days * 3600 * 24;
    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff - hours * 3600) / 60);
    const seconds = Math.floor(diff - hours * 3600 - minutes * 60);
    this.tooltipStr = '';
    if (hours > 0) {
      this.tooltipStr += hours + ':';
      if (minutes < 10) {
        this.tooltipStr += '0' + minutes;
      } else {
        this.tooltipStr += minutes;
      }
    } else {
      this.tooltipStr += minutes;
    }
    if (seconds < 10) {
      this.tooltipStr += ':0' + seconds;
    } else {
      this.tooltipStr += ':' + seconds;
    }
    if (days >= 1) {
      const strDays = 'days';
      this.translate.get(strDays)
        .subscribe((res: string) => {
          this.tooltipStr = days + ' ' + res + ' ' + this.tooltipStr;
        });
    }

    let response = ""
    if(this.isAlert){
      if (days < 1) {
        response = "blue"
        this.timerflag.emit({id:this.case_id,color:response})
      } else if (days >= 1 && days < 3) {
        response = "yellow"
        this.timerflag.emit({id:this.case_id,color:response})
      } else {
        response = "red"
        this.timerflag.emit({id:this.case_id,color:response})
      }

      if(this.starttime && this.endtime){
        response = "blue_opacity"
        this.timerflag.emit({id:this.case_id,color:response})
      }
      
    }else{
      if (minutes < 5 && hours < 1 && days < 1) {
        response = "blue"
        this.timerflag.emit({id:this.case_id,color:response})
      } else if (minutes < 10 && hours < 1 && days < 1) {
        response = "yellow"
        this.timerflag.emit({id:this.case_id,color:response})
      } else {
        response = "red"
        this.timerflag.emit({id:this.case_id,color:response})
      }
    }
   
    
  }
}
